import styles from './Services.module.css'

function Services() {
    const services = [
        {
            id: 1,
            icon: '📊',
            title: 'Soluciones Contables Inteligentes',
            description: 'Automatización y optimización de procesos contables con tecnología de vanguardia.',
            features: [
                'Conciliación bancaria automatizada',
                'Comparación de Token DIAN con libros auxiliares',
                'Reportes financieros en tiempo real',
                'Análisis predictivo de flujos de caja'
            ]
        },
        {
            id: 2,
            icon: '🤖',
            title: 'Agentes de IA Personalizados',
            description: 'Desarrollamos agentes inteligentes específicos para las necesidades de tu empresa.',
            features: [
                'Análisis automático de documentos',
                'Clasificación inteligente de transacciones',
                'Detección de anomalías y fraudes',
                'Asistentes virtuales para consultas contables'
            ]
        },
        {
            id: 3,
            icon: '⚡',
            title: 'Automatización de Procesos',
            description: 'Elimina tareas repetitivas y libera tiempo para el análisis estratégico.',
            features: [
                'Carga automática de comprobantes',
                'Conciliación de cuentas por pagar/cobrar',
                'Generación automática de reportes',
                'Integración con sistemas ERP'
            ]
        },
        {
            id: 4,
            icon: '🔍',
            title: 'Análisis y Business Intelligence',
            description: 'Convierte tus datos contables en insights accionables.',
            features: [
                'Dashboards interactivos',
                'Indicadores financieros clave (KPIs)',
                'Pronósticos basados en IA',
                'Benchmarking sectorial'
            ]
        }
    ]

    return (
        <div className={styles.servicesPage}>
            <div className={styles.hero}>
                <div className={styles.container}>
                    <h1 className={styles.title}>Nuestros Servicios</h1>
                    <p className={styles.subtitle}>
                        Soluciones tecnológicas integrales para transformar tu gestión contable y empresarial
                    </p>
                </div>
            </div>

            <div className={styles.servicesSection}>
                <div className={styles.container}>
                    <div className={styles.grid}>
                        {services.map((service) => (
                            <div key={service.id} className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <div className={styles.icon}>{service.icon}</div>
                                    <h3 className={styles.cardTitle}>{service.title}</h3>
                                </div>
                                <p className={styles.cardDescription}>{service.description}</p>
                                <ul className={styles.featuresList}>
                                    {service.features.map((feature, index) => (
                                        <li key={index} className={styles.feature}>
                                            <span className={styles.checkmark}>✓</span>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services
